export enum MarketingChannels {
  mctc = 'mctc',
  emlcid = 'emlcid',
  affcid = 'affcid',
  afmcid = 'afmcid',
  icmcid = 'icmcid',
  mdpcid = 'mdpcid',
  semcid = 'semcid',
  olacid = 'olacid',
  brandcid = 'brandcid',
  seocid = 'seocid',
  emldtl = 'emldtl',
  afflid = 'afflid',
  kword = 'kword',
  icmdtl = 'icmdtl',
  mdpdtl = 'mdpdtl',
  semdtl = 'semdtl',
  oladtl = 'oladtl',
  gclid = 'gclid',
  lnkloc = 'lnkloc',
  // eslint-disable-next-line camelcase
  k_user_id = 'k_user_id'
}
